import ImagePicker from 'components/ImagePicker'
import React from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import LinkTargetPicker from 'scenes/Cms/components/LinkTargetPicker'
import UrlPicker, { UrlType } from 'scenes/Cms/components/UrlPicker'
import { selectAppHomePageValidation } from 'selectors/validation'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import MenuCategorySelector from './MenuCategorySelector'

type Props = {
  blockId: string
  contentBlock: ContentBlockData
  prefix?: string // Optional prefix for nested form fields
}

const FeaturedContent = ({ blockId, contentBlock, prefix }: Props) => {
  const imageValidation = useSelector(selectAppHomePageValidation)
  if (!imageValidation) return <></>
  const { type } = contentBlock

  if (type !== 'featured_content') return <></>
  const { image, url } = contentBlock

  // Use prefix if provided, otherwise use blockId directly
  const idWithPrefix = prefix ? `${prefix}.${blockId}` : blockId

  return (
    <>
      <ImagePicker
        className="mb-l"
        name={`${idWithPrefix}.image`}
        value={image}
        validations={{
          image: true,
        }}
        validationErrors={{
          image: I18n.t('validations.is_required'),
        }}
        imageValidations={imageValidation}
      />
      <UrlPicker
        id={idWithPrefix}
        type="image"
        url={url}
        required={false}
        hasQueryParam
      >
        <LinkTargetPicker
          id={idWithPrefix}
          url={url}
          linkTarget={contentBlock.settings.link_target}
        />
      </UrlPicker>
      {url.type === UrlType.Inapp &&
        url.inapp?.startsWith('thanx://ordering-menu') && (
          <MenuCategorySelector id={idWithPrefix} url={contentBlock.url} />
        )}
    </>
  )
}

export default FeaturedContent
